// Minimal DER reader/writer: exactly what RFC 3161 request/response handling needs.
export interface Tlv { tag: number; start: number; header: number; len: number; value: Uint8Array; raw: Uint8Array }

export function readTlv(buf: Uint8Array, at = 0): Tlv {
  const tag = buf[at]!;
  let len = buf[at + 1]!;
  let header = 2;
  if (len & 0x80) {
    const n = len & 0x7f;
    if (n === 0 || n > 4) throw new Error("unsupported DER length");
    len = 0;
    for (let i = 0; i < n; i++) len = len * 256 + buf[at + 2 + i]!;
    header += n;
  }
  if (at + header + len > buf.length) throw new Error("DER truncated");
  return { tag, start: at, header, len, value: buf.subarray(at + header, at + header + len), raw: buf.subarray(at, at + header + len) };
}

export function children(t: Tlv): Tlv[] {
  const out: Tlv[] = [];
  let at = 0;
  while (at < t.value.length) { const c = readTlv(t.value, at); out.push(c); at += c.header + c.len; }
  return out;
}

function lenBytes(n: number): number[] {
  if (n < 0x80) return [n];
  const b: number[] = [];
  while (n > 0) { b.unshift(n & 0xff); n = Math.floor(n / 256); }
  return [0x80 | b.length, ...b];
}

export const tlv = (tag: number, ...parts: Uint8Array[]): Uint8Array => {
  const body = parts.reduce((n, p) => n + p.length, 0);
  const out = new Uint8Array([tag, ...lenBytes(body), ...new Uint8Array(body)]);
  let o = out.length - body;
  for (const p of parts) { out.set(p, o); o += p.length; }
  return out;
};

export function oid(dotted: string): Uint8Array {
  const n = dotted.split(".").map(Number);
  const out = [40 * n[0]! + n[1]!];
  for (const x of n.slice(2)) {
    const b = [x & 0x7f];
    let v = Math.floor(x / 128);
    while (v > 0) { b.unshift((v & 0x7f) | 0x80); v = Math.floor(v / 128); }
    out.push(...b);
  }
  return tlv(0x06, new Uint8Array(out));
}

export function oidToString(v: Uint8Array): string {
  const parts = [Math.floor(v[0]! / 40), v[0]! % 40];
  let acc = 0;
  for (const b of v.subarray(1)) { acc = acc * 128 + (b & 0x7f); if (!(b & 0x80)) { parts.push(acc); acc = 0; } }
  return parts.join(".");
}

export const integer = (bytes: Uint8Array) => tlv(0x02, bytes[0]! & 0x80 ? new Uint8Array([0, ...bytes]) : bytes);
